import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AvatarComponent } from '../../../../components/avatar/avatar.component';

@Component({
  selector: 'app-signaling-block-avatar',
  imports: [MatIcon, AvatarComponent, NgClass],
  templateUrl: './signaling-block-avatar.component.html',
  styleUrl: './signaling-block-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'size-18 rounded-full relative',
    '[class.disabled]': 'disabled()',
  },
})
export class SignalingBlockAvatarComponent {
  src = input<string>();

  disabled = input(false, { transform: booleanAttribute });

  imageChange = output();

  handleClick() {
    if (this.disabled()) {
      return;
    }

    this.imageChange.emit();
  }
}
